import styled from 'styled-components';
import { Layout } from '@/ui';
import { COLORS } from '@/theme';
import { ChannelType } from '@/models/channel.model';
import { getHeaderThemeColors } from '../../helpers';

export const StyledLayout = styled(Layout)`
  &.ant-layout {
    min-height: 100vh;
    flex: 1;
    background: ${COLORS.WHITE};
  }
`;

export const StyledTopBlock = styled.div<{
  $channelType?: ChannelType;
}>`
  padding: 2rem 1.5rem 1rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background-color: ${({ theme, $channelType }) => theme.token[getHeaderThemeColors($channelType)?.background]};
`;

export const StyledImageHolder = styled.div`
  overflow: hidden;

  img {
    aspect-ratio: 18 / 6;
    width: 100%;
    object-fit: contain;
  }
`;

export const StyledLogoutButton = styled.div`
  padding: 0 1.5rem 1rem 1.5rem;
  margin-top: auto;

  button {
    width: calc(18rem - 3.1rem) !important;
  }
`;
